export default __webpack_public_path__ + "static/N0184-6f18bcb43edd4b719d99888dfed7425a.png";